import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import EditCategory from './dialogs/EditCategory.vue'
import EditCollection from './dialogs/EditCollection.vue'
import { deleteProduct as apiDeleteProduct } from '@/features/printstore/PrintStoreApi'
import { deleteCollection as apiDeleteCollection } from '@/features/printstore/PrintStoreApi'
import { deletePackage as apiDeletePackage } from '@/features/printstore/PrintStoreApi'
import { EventBus, Events } from '@/eventbus/EventBus'
import AddProduct from './dialogs/AddProduct.vue'
import EditPackage from '@/features/printstore/dialogs/EditPackage.vue'
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue'
import { sendMail } from '@/api/api'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    showSaveCustomFiles() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.showSaveCustomFiles &&
        this.rootStore.user.loggedIn
        ? true
        : false
    },
    hidePrice() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.hidePricing
        ? true
        : false
    },
    hideOwnPrice() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.hideOwnPricing
        ? true
        : false
    },
    printStoreColor() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.color
        ? this.rootStore.theme.customFields.printStore.color
        : false
    },
    hideRijnjaContent() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.hideDefaultContent
        ? this.rootStore.theme.customFields.printStore.hideDefaultContent
        : false
    },
    hideProductRequest() {
      return this.rootStore.theme.customFields.printStore &&
        this.rootStore.theme.customFields.printStore.hideProductRequest
        ? true
        : false
    },
    printStoreTitle() {
      return this.rootStore.theme.printStore.name
        ? this.rootStore.theme.printStore.name
        : ''
    }
  },
  methods: {
    confirmationDialog(message, confirmButtonCaption, callback, title) {
      this.$modal.show(
        ConfirmationDialog,
        {
          title: title,
          text: message,
          buttons: [
            {
              title: 'Annuleren',
              class: 'pill-button secondary'
            },
            {
              title: confirmButtonCaption,
              class: 'pill-button',
              handler: () => {
                callback()
              }
            }
          ]
        },
        {
          width: 400,
          height: 'auto'
        }
      )
    },
    addCategory() {
      this.$modal.show(
        EditCategory,
        {},
        {
          adaptive: true,
          width: 340,
          clickToClose: false
        }
      )
    },
    editCategory(category) {
      this.$modal.show(
        EditCategory,
        {
          category: category
        },
        {
          adaptive: true,
          width: 340,
          clickToClose: false
        }
      )
    },
    addCollection() {
      this.$modal.show(
        EditCollection,
        {},
        {
          adaptive: true,
          width: 480,
          clickToClose: false
        }
      )
    },
    addPackage() {
      this.$modal.show(
        EditPackage,
        {},
        {
          adaptive: true,
          width: 480,
          clickToClose: false
          //height: 'auto'
          //scrollable: true
        }
      )
    },
    addProduct() {
      this.$modal.show(
        AddProduct,
        {},
        {
          adaptive: true,
          width: 420
        }
      )
    },
    deleteProducts(ids) {
      return new Promise((resolve, reject) => {
        this.confirmationDialog(
          'Wilt u deze ontwerpen verwijderen?',
          'Verwijderen',
          async () => {
            for (const id of ids) {
              await apiDeleteProduct(id)
            }
            EventBus.emit(Events.COLLECTION_UPDATED)
            resolve()
          },
          'Ontwerpen verwijderen'
        )
      })
    },
    deleteProduct(product) {
      return new Promise((resolve, reject) => {
        this.confirmationDialog(
          `Weet u zeker dat u het ontwerp <strong>${product.name}</strong> permanent wilt verwijderen?<br>Let op, niemand kan dit ontwerp dan meer bestellen.`,
          'Verwijderen',
          async () => {
            await apiDeleteProduct(product.id)
            EventBus.emit(Events.COLLECTION_UPDATED)

            if (product.sourceProductId) {
              await sendMail({
                to: 'camiel@rijnja.nl',
                subject: 'Custom product verwijderd',
                message: `User ${this.rootStore.user.username} heeft product ${product.name} - ${product.id} verwijderd.`,
                userInfo: {
                  email: this.rootStore.user.username
                }
              })
            }

            resolve()
          },
          'Ontwerp verwijderen'
        )
      })
    },
    deleteCollection(id, name) {
      return new Promise((resolve, reject) => {
        this.confirmationDialog(
          `Weet u zeker dat u de collectie <strong>${name}</strong> wilt verwijderen?`,
          'Verwijderen',
          async () => {
            await apiDeleteCollection(id)
            resolve()
          },
          'Collectie verwijderen'
        )
      })
    },
    deletePackage(id, name) {
      return new Promise((resolve, reject) => {
        this.confirmationDialog(
          `Weet u zeker dat u het pakket <strong>${name}</strong> wilt verwijderen?`,
          'Verwijderen',
          async () => {
            await apiDeletePackage(id)
            resolve()
          },
          'Pakket verwijderen'
        )
      })
    },
    itemIsInCart(product) {
      return this.printStoreStore.orderDetails.cart.find(
        (item) => item.id === product.id
      )
    },
    isOwnPrintStore(id) {
      return this.rootStore.user.printStore?.id === id
    },
    productImage(product, productType, size, color) {
      let image = ''
      if (!product) {
        return ''
      } else if (product.previewImage && product.customImage) {
        return product.previewImage
      } else if (product.previewImage) {
        image = product.previewImage
      } else if (productType.colors) {
        const defaultColor = color || productType.colors.default

        const defaultImage = product.previews.find(
          (img) => img.colour === defaultColor
        )

        if (defaultImage) {
          image = defaultImage.uuid
        }
      } else if (product.previews.length) {
        image = product.previews[0].uuid
      }

      return image
        ? `/media/print-store/${product.printStoreId}/preview/${image}/${size}`
        : ''
    }
  }
}
